import { Component, effect, inject, input, Type, untracked, viewChild } from '@angular/core';
import {
  Attributes,
  DynamicComponentService,
} from '@core/services/template/dynamic-component.service';
import { TemplateHostDirective } from '@shared/directives/template-host.directive';
import { IDynamicComponent } from '@core/services/template/dynamic.component';

// Deliberately NOT OnPush: the dynamically created component is inserted into this
// component's view, so its change detection runs only when this view is checked.
// Quest components rely on plain zone ticks (setTimeout/setInterval driven animations),
// which an unmarked OnPush host would swallow.
@Component({
  selector: 'recrewt-section-content',
  templateUrl: './section-content.component.html',
  styleUrls: ['./section-content.component.scss'],
  imports: [TemplateHostDirective],
})
export class SectionContentComponent {
  private tplLoader = inject(DynamicComponentService);

  readonly data = input<unknown>(null);

  readonly attributes = input<Attributes>();

  readonly sectionType = input<Type<IDynamicComponent> | null>(null);

  readonly tplHost = viewChild(TemplateHostDirective);

  constructor() {
    // Reload the dynamic component whenever the section type or data change.
    // `attributes` is read untracked: callers bind object literals that get a fresh
    // identity on every parent change-detection cycle, and tracking it would tear
    // down and recreate the loaded component on every tick.
    effect(() => {
      const tplHost = this.tplHost();
      const sectionType = this.sectionType();
      const data = this.data();
      if (!tplHost) {
        return;
      }
      tplHost.viewContainerRef.clear();
      if (!sectionType) {
        return;
      }
      const attributes = untracked(this.attributes);
      this.tplLoader.loadComponent(tplHost.viewContainerRef, sectionType, data, attributes);
    });
  }
}
